var _radialGradient, _linearGradient;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessionConversions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 129,
    viewBox: "0 0 332 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "9i43jw451b"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2859",
    width: 332,
    height: 129,
    rx: 16,
    transform: "translate(-8523 -11790)",
    style: {
      fill: "url(#zvbbnjs2wa)"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q1x40a1jhd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2905",
    style: {
      fill: "none"
    },
    d: "M0 0h137.764v122.491H0z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "zvbbnjs2wa",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5eeff"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "w5puxsgvdc",
    x1: 0.5,
    y1: 0.312,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cdf7f1",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63f5d9"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Insight Card Inside Graphic",
    transform: "translate(8523 11790)",
    style: {
      clipPath: "url(#9i43jw451b)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2772"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1293",
    d: "M78.347 63.01v84.837h18.995V84.99L78.594 63.01z",
    transform: "translate(-8543.528 -11800.871)",
    style: {
      fill: "url(#w5puxsgvdc)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1294",
    d: "M162.456 67.82v75.331h18.994V51.343z",
    transform: "translate(-8577.375 -11796.176)",
    style: {
      fill: "url(#w5puxsgvdc)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1295",
    d: "M36.292 83.089v66.257h18.995V66.735z",
    transform: "translate(-8526.605 -11802.37)",
    style: {
      fill: "url(#w5puxsgvdc)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1296",
    d: "m121.446 103.4-1.046-1.226v55.662h19v-70.01z",
    transform: "translate(-8560.451 -11810.857)",
    style: {
      fill: "url(#w5puxsgvdc)",
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2769"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2768",
    style: {
      clipPath: "url(#q1x40a1jhd)"
    },
    transform: "translate(-8512 -11775.515)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1297",
    d: "m137.764 0-35.1 6.784 5.842 6.734L74.9 42.666 47.409 10.431 3.115 48.567a8.964 8.964 0 0 0 11.7 13.586l30.643-26.384L73 68.054l47.25-40.994 5.842 6.734z",
    style: {
      fill: "#38e3c9",
      opacity: 0.5,
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionConversions);
export default __webpack_public_path__ + "static/media/session-conversions.14d86a0031c6d60abc3a9d9d209edc21.svg";
export { ForwardRef as ReactComponent };